//Variable que indica la activacion de encriptacion a todas las peticiones
export const algorithm = process.env.REACT_APP_ENCRIPTED_ALGORITHM
export const prPublicKeyDSC = process.env.REACT_APP_ENCRIPTED_PUBLICDSC_KEY
export const prPublicKey = process.env.REACT_APP_ENCRIPTED_PUBLIC_KEY
export const prPrivateKey = process.env.REACT_APP_ENCRIPTED_PRIVATE_KEY
export const APIKEYGOOGLE = process.env.REACT_APP_GOOGLE_API_KEY
export const IPDEFAULT = process.env.REACT_APP_IPDEFAULT
export const ReferCredentials = process.env.REACT_APP_REFER_CREDENTIALS

//Variable que indica la activacion de encriptacion a todas las peticiones
export const constEncripted = {
  encriptedBody: false
};

//URL's correspondientes a sus respectivos ambientes
export const ApiUrl = {
  ambient: `${process.env.REACT_APP_DSONBOARDING_API}`
}

export const ApiUrlVC = {
  ambientVC: `${process.env.REACT_APP_URL_VERIFY_API}`
}

//URL's correspondientes a sus respectivos ambientes FACIAL y de finger
export const ApiIdentyUrl = {
  fingerAI: `${process.env.REACT_APP_IDENTY_FINGERAI}`,
  faceAI: `${process.env.REACT_APP_IDENTY_FACEAI}`
}

//URL's correspondientes a sus respectivos ambientes de IDENTY
export const ApiFatechUrl = {
  ambient: `${process.env.REACT_APP_FACTECH}`,
  ambientBase: `${process.env.REACT_APP_FACTECH_BASE}`
}

//URL's correspondientes a sus respectivos ambientes MICROPBLICK
export const ApiKeyMicroblick = {
  getKey: `${process.env.REACT_APP_API_KEY}`
}